export interface Consultant {
  full_name: string
  type_division: DivisionType
  get_type_division_display: string
  main_branch: string
  branches: string
  phone?: string
  inn?: string
}

export enum CommonStatus {
  in_process = 'in_process',
  waiting = 'waiting',
  error = 'error',
  consideration = 'consideration',
  delivered = 'delivered',
  denied = 'denied',
  given = 'given',
  notfound = 'notfound',
  awaiting = 'awaiting',
}

export enum CartType {
  visa = 'visa',
  elcart = 'elcart',
}

export const DivisionType = {
  M: 'M',
  B: 'B',
} as const
export type DivisionType = (typeof DivisionType)[keyof typeof DivisionType]
